/* eslint-disable no-console */
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import {
  IFRAME_BREAKPOINT,
  useFormatedWindowSize,
  getVariablesFromJSON,
  getVariablesToBeApplied,
  validateBaseUrl,
} from './TableauVizualization.utils';

import { marketFilters, riskFilters } from './QueryConfig';

import './TableauVizualization.scss';
import { REPORT_TYPES } from '../../utils/constants/constants';
import { useToast } from '../../contexts/Toast';
import { validateJsonAndGetTicket, removeEmptySpacesObject } from './queryValidation';
import { StoreContext } from '../../store/storeContext';

// Fix for AUT-4534, should be removed when the API is fixed
const DEALER_STATE_TEXT = '{"2":{"territoryTypeId":2,"territoryTypeNm":"Dealer State"}}';
const OWNER_STATE_TEXT = '{"1":{"territoryTypeId":1,"territoryTypeNm":"Owner State"}}';

function TableauVizualization({
  setIsLoading,
  refreshQuery,
  setQueryInfo,
  query,
  vizReference,
  setVizReference,
  reportTypeId,
  tableauToken,
}) {
  const { setToastState } = useToast();

  const [width, height] = useFormatedWindowSize();
  let viz;
  const history = useHistory();
  const { actions } = useContext(StoreContext);


  const displayTableauReport = () => {
    const vizElement = document.getElementById("tableauViz");
    vizElement.display = 'block';
    setIsLoading(false);
  }


  const initViz = (baseurl, filters, params) => {
    const vizElement = document.getElementById("tableauViz");
    vizElement.display = 'none';

    viz = new window.tableau.TableauViz();
    const sanitizedBaseUrl = baseurl.replace('trusted/#TICKET#/', '');
    viz.src = sanitizedBaseUrl;
    viz.token = tableauToken;
    viz.hideTabs = true;
    viz.toolbar = 'hidden';
    viz.addEventListener('firstinteractive', displayTableauReport);
    if (reportTypeId === REPORT_TYPES.marketReportTypeId) {
      viz.height = '1000px';
    } else {
      viz.height = '1400px';
    }

    filters.forEach(filter => {
      const filterElement = document.createElement("viz-filter");
      filterElement.setAttribute("field", filter.tableauKey);
      let filterValues = filter.parameterValues;
      // Check if filterValues is an array and contains strings with commas
      if (Array.isArray(filterValues) && filterValues.some(v => typeof v === 'string' && v.includes(','))) {
        filterValues = filterValues.map(v => v.replace(/,/g, '\\,'));
      } 
      filterElement.setAttribute("value", filterValues);
      viz.appendChild(filterElement);
    });
    params.forEach(param => {
      const vizParameter = document.createElement("viz-parameter");
      vizParameter.setAttribute("name", param.tableauKey);
      vizParameter.setAttribute("value", param.parameterValues);
      viz.appendChild(vizParameter);
    });
    setVizReference(viz);
    vizElement.appendChild(viz);
  };

  const retrieveTicket = async () => {
    let response;
    try {
      response = await validateJsonAndGetTicket(reportTypeId, query, 'run');
    } catch (e) {
      actions.errorAction(e);
    }
    if (response?.userQueryOptionStatusTypeId !== 1) {
      setToastState({
        open: true,
        severity: 'error',
        status: response.userQueryOptionStatusTypeId,
        message: response.userQueryOptionStatusAdditionalDetails,
      });
      history.goBack();
    } else {
      const responseString = response.userQueryOptionJSON;
      const newQuery = JSON.parse(response.userQueryOptionJSON);

      // Fix for AUT-4534, should be removed when the API is fixed
      if (responseString.includes(DEALER_STATE_TEXT.substring(0, DEALER_STATE_TEXT.length - 2))) {
        newQuery.territorySelection.territoryTypes = JSON.parse(DEALER_STATE_TEXT);
      } else if (responseString.includes(OWNER_STATE_TEXT.substring(0, OWNER_STATE_TEXT.length - 2))) {
        newQuery.territorySelection.territoryTypes = JSON.parse(OWNER_STATE_TEXT);
      }



      const baseUrl = validateBaseUrl(Object.values(query.chosenReports)[0].visualizationView);

      const trustedUrl = baseUrl;
      newQuery.chosenReports = query.chosenReports;
      newQuery.queryName = query.queryName;
      const reportId = Object.keys(newQuery.chosenReports)[0];

      if (newQuery?.riskOptionsSelection?.riskDynamicFields?.[reportId]) {
        newQuery.riskOptionsSelection.riskDynamicFields =
          newQuery?.riskOptionsSelection?.riskDynamicFields?.[reportId];
      }

      if (newQuery?.riskOptionsSelection?.focusLender) {
        const clearedFocusLender = removeEmptySpacesObject(
          Object.values(newQuery?.riskOptionsSelection?.focusLender)[0],
        );
        newQuery.riskOptionsSelection.focusLender = {
          [clearedFocusLender.lenderId]: clearedFocusLender,
        };
      }

      setQueryInfo(newQuery);
      return [trustedUrl, newQuery];
    }
    return '';
  };

  useEffect(() => {
    const vizElement = document.getElementById("tableauViz");
    if (vizElement) {
      vizElement.width = `${width}px`;
      vizElement.height = `${height}px`;
    }
  }, [width, height]);

  useEffect(() => {
    if (vizReference !== null) {
      vizReference.dispose();
    }
    setIsLoading(true);

    if (!query) {
      history.goBack();
    } else if (JSON.stringify(query?.chosenReports) !== JSON.stringify({})) {
      retrieveTicket()
        .then((e) => {
          const [trustedUrl, newQuery] = e;
          if (newQuery !== undefined && Object.keys(newQuery).length > 0) {
            const config =
              reportTypeId === REPORT_TYPES.marketReportTypeId ? marketFilters : riskFilters();

            const processingVariableOptions = getVariablesFromJSON(config, newQuery);
            getVariablesToBeApplied(
              processingVariableOptions,
              initViz,
              trustedUrl,
            );
          }
        })
        .catch((error) => {
          actions.errorAction(error);
          setIsLoading(false);
        });
    }
  }, [refreshQuery]);

  return  <div id="tableauViz"/>
}

TableauVizualization.propTypes = {
  setIsLoading: PropTypes.func.isRequired,
  refreshQuery: PropTypes.bool.isRequired,
  setQueryInfo: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
  vizReference: PropTypes.object,
  setVizReference: PropTypes.func.isRequired,
  reportTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tableauToken: PropTypes.string,
};

export { TableauVizualization, IFRAME_BREAKPOINT };
